import { useControllerData } from '../../contexts/main/controllerContext';
import { usePromisify } from './usePromisify';

export const useGetResolvedError = () => {
  const { getResolvedError } = useControllerData();
  return usePromisify(getResolvedError);
};
